import { StorageWrapper } from './StorageWrapper';

export const LocalStorage = StorageWrapper.create(() => window.localStorage);

export const SessionStorage = StorageWrapper.create(() => window.sessionStorage);
